export default __webpack_public_path__ + "static/media/whatsappIconCircle.75fdd887.svg";